import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaInstagram, FaFacebook, FaTwitter } from 'react-icons/fa';
import { socialLinks } from '../../data/links';
import './Footer.css';

const sectionLinks = [
  { href: '#home', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#experience', label: 'Experience' },
  { href: '#services', label: 'Services' },
  { href: '#portfolio', label: 'Portfolio' },
  { href: '#contact', label: 'Contact' }
];

const footerSocials = [
  { Icon: FaLinkedin, href: socialLinks.linkedin, label: 'LinkedIn' },
  { Icon: FaGithub, href: socialLinks.github, label: 'GitHub' },
  { Icon: FaInstagram, href: socialLinks.instagram, label: 'Instagram' },
  { Icon: FaFacebook, href: socialLinks.facebook, label: 'Facebook' },
  { Icon: FaTwitter, href: socialLinks.twitter, label: 'Twitter' }
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.06, delayChildren: 0.12 }
  }
};

const item = {
  hidden: { opacity: 0, y: 16 },
  show: { opacity: 1, y: 0, transition: { type: 'spring', damping: 26, stiffness: 140 } }
};

const spring = { type: 'spring', stiffness: 380, damping: 18 };

const Footer = () => {
  return (
    <motion.footer
      id="footer"
      className="footer"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: '-40px' }}
      variants={container}
    >
      <motion.a href="#home" className="footerLogo" variants={item}>
        Rasheed Abu Khader
      </motion.a>
      <motion.ul className="footerLinks" variants={container}>
        {sectionLinks.map((link, i) => (
          <motion.li key={i} variants={item}>
            <motion.a href={link.href} whileHover={{ y: -2 }} transition={spring}>
              {link.label}
            </motion.a>
          </motion.li>
        ))}
      </motion.ul>
      <motion.div className="footerSocials" variants={container}>
        {footerSocials.map(({ Icon, href, label }, i) => (
          <motion.a
            key={i}
            href={href}
            rel="noreferrer"
            target="_blank"
            aria-label={label}
            variants={item}
            whileHover={{ scale: 1.2, y: -5 }}
            whileTap={{ scale: 0.92 }}
            transition={spring}
          >
            <Icon />
          </motion.a>
        ))}
      </motion.div>
      <motion.div className="copyRight" variants={item}>
        <small>&copy; {new Date().getFullYear()} All Rights Reserved</small>
      </motion.div>
    </motion.footer>
  );
};

export default Footer;
